import { createSlice } from "@reduxjs/toolkit";

interface modal {
  modalName: string;
  isModalOpen: boolean;
  modalData: unknown;
}

const initialState: modal = {
  modalName: "",
  isModalOpen: false,
  modalData: null,
};

export const modalSlice = createSlice({
  // Name of our slice which we will call in our store
  name: "modal",
  // Initial state
  initialState: initialState,

  // Our method inside reducers to change our state value
  reducers: {
    openModal: (state, action) => {
      state.modalName = action.payload.modalName;
      state.isModalOpen = action.payload.isModalOpen;
      state.modalData = action.payload.modalData;
    },
    closeModal: (state) => {
      state.modalName = "";
      state.isModalOpen = false;
      state.modalData = null;
    },
  },
});

// Exporting our method to be called in the component
export const { openModal, closeModal } = modalSlice.actions;

export default modalSlice.reducer;
